// Step 18 — outer AI application shell.
//
// Composition:
//   AIWorkspaceProvider   — supplies /ai/context/ to every child page
//   AISidebar             — global + deal-scoped nav
//   AIHeader              — workspace / deal status chip
//   <Outlet/>             — the routed page
//
// The provider sits INSIDE this component so pages nested under
// <Route element={<AIShell/>}> can call useAIWorkspace() without the
// caller having to remember to wrap the tree.

import { Outlet } from "react-router-dom";

import AIHeader from "./AIHeader";
import AISidebar from "./AISidebar";
import { AIError } from "./AIPrimitives";
import { AIWorkspaceProvider, useAIWorkspace } from "./AIWorkspaceContext";

function ShellBody() {
  const { error } = useAIWorkspace();
  return (
    <div className="qai-shell-root">
      <AISidebar />
      <div className="qai-shell-content">
        <AIHeader />
        <main className="qai-shell-main">
          <AIError message={error} />
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default function AIShell() {
  return (
    <AIWorkspaceProvider>
      <ShellBody />
    </AIWorkspaceProvider>
  );
}
